<dhp-filter-strings-select-dialog
  class="hidden md:flex"
  [filterName]="filterName"
  [originalStrings]="sourceItems()"
  (stringsOutput)="selectedSources.emit($event)"
/>
<dhp-filter-strings-select-accordion
  class="md:hidden"
  [filterName]="filterName"
  [originalStrings]="sourceItems()"
  (stringsOutput)="selectedSources.emit($event)"
/>
